import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';

const DISCOVERY_CALL_LINK = "https://docs.google.com/forms/d/e/1FAIpQLSffPqByMgvINjLjZurzxgeknKrY_jooGe_Co58QOYCNqHezZA/viewform";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: 'Home', href: '#home' },
    { name: 'Offerings', href: '#offerings' },
    { name: 'About', href: '#about' },
    { name: 'Testimonials', href: '#testimonials' },
    { name: 'Apply', href: DISCOVERY_CALL_LINK, external: true }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-md z-50 border-b-2 border-[#E07856]/20">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#home" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_e00c593a-5f41-4154-9704-94e459198325/artifacts/yqg48r4q_Untitled%20design%20(7).png"
              alt="Unstoppable You"
              className="h-12 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                target={item.external ? "_blank" : undefined}
                rel={item.external ? "noopener noreferrer" : undefined}
                className={`text-[#2d2d2d] hover:text-[#E07856] transition-colors font-semibold ${
                  item.name === 'Apply' ? 'bg-gradient-to-r from-[#E07856] to-[#D45B3A] text-white px-6 py-2 rounded-full hover:shadow-lg hover:scale-105 transition-all' : ''
                }`}
              >
                {item.name}
              </a>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-[#2d2d2d]"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="md:hidden mt-4 pb-4 border-t border-[#E07856]/20 pt-4"
          >
            <div className="flex flex-col gap-4">
              {navItems.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  target={item.external ? "_blank" : undefined}
                  rel={item.external ? "noopener noreferrer" : undefined}
                  onClick={() => setIsOpen(false)}
                  className={`text-[#2d2d2d] hover:text-[#E07856] transition-colors font-semibold ${
                    item.name === 'Apply' ? 'bg-gradient-to-r from-[#E07856] to-[#D45B3A] text-white px-6 py-3 rounded-full text-center' : ''
                  }`}
                >
                  {item.name}
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export const Footer = () => {
  return (
    <footer className="bg-[#333333] text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Unstoppable You</h3>
            <p className="text-[#cccccc]">
              Transformation coaching for people ready to become fully themselves.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <div className="flex flex-col gap-2">
              <a href="#offerings" className="text-[#cccccc] hover:text-white transition-colors">Offerings</a>
              <a href="#about" className="text-[#cccccc] hover:text-white transition-colors">About</a>
              <a href="#testimonials" className="text-[#cccccc] hover:text-white transition-colors">Testimonials</a>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Connect</h3>
            <div className="flex flex-col gap-2">
              <a href="mailto:garima@unstoppableyou.in" className="text-[#cccccc] hover:text-white transition-colors">
                garima@unstoppableyou.in
              </a>
              <a href="tel:+917411750372" className="text-[#cccccc] hover:text-white transition-colors">
                +91 74117 50372
              </a>
              <a href="https://wa.me/917411750372" target="_blank" rel="noopener noreferrer" className="text-[#cccccc] hover:text-white transition-colors">
                WhatsApp
              </a>
              <a href="https://www.instagram.com/unstoppableyoubygarima" target="_blank" rel="noopener noreferrer" className="text-[#cccccc] hover:text-white transition-colors">
                Instagram
              </a>
              <a href="https://www.linkedin.com/in/garima-unstoppableyou" target="_blank" rel="noopener noreferrer" className="text-[#cccccc] hover:text-white transition-colors">
                LinkedIn
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#555555] pt-8 text-center text-[#cccccc] text-sm">
          <p>&copy; 2025 Unstoppable You. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
